import React from "react";
import { Box } from "@material-ui/core";

import { color, fontSize, spacingDefaults } from "style/constants";

interface InstructionsBoxProps {
  instructions: string[];
}

const InstructionsBox: React.FC<InstructionsBoxProps> = ({ instructions }) => (
  <Box
    border={`1px solid ${color.GRAY}`}
    borderRadius="12px"
    padding="24px 32px"
    maxWidth="520px"
    textAlign="left"
    marginBottom={spacingDefaults.large}
  >
    <Box
      textAlign="center"
      marginBottom={spacingDefaults.normal}
      color={color.DARKRED}
    >
      <Box fontWeight={700} fontSize={fontSize.large}>
        ATTENTION
      </Box>
      <Box fontWeight={700} fontSize={fontSize.medium}>
        Please read the listed instructions below carefully and follow these
        steps to ensure proper registration:
      </Box>
    </Box>
    <ul
      style={{
        margin: "0 auto",
        paddingLeft: "20px",
        color: color.NETURALS700,
        fontWeight: 400,
        width: "264px"
      }}
    >
      {instructions.map((item, index) => (
        <li key={index}>{item}</li>
      ))}
    </ul>
  </Box>
);

export default InstructionsBox;
